import { render, staticRenderFns } from "./ViewGoalDialog.vue?vue&type=template&id=4e32f343&scoped=true"
import script from "./ViewGoalDialog.vue?vue&type=script&lang=js"
export * from "./ViewGoalDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewGoalDialog.vue?vue&type=style&index=0&id=4e32f343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32f343",
  null
  
)

export default component.exports